import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import {
    alpha,
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Typography,
    useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const RegistrationSuccessPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const trackingNumber = location?.state?.trackingNumber;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.success.main,
          0.1
        )} 0%, ${alpha(theme.palette.primary.main, 0.1)} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 4,
      }}
    >
      <Container maxWidth="md">
        <Card sx={{ textAlign: "center", p: 4 }}>
          <CardContent>
            <CheckCircleIcon
              sx={{
                fontSize: 80,
                color: theme.palette.success.main,
                mb: 3,
              }}
            />

            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              sx={{ fontWeight: 700, color: theme.palette.success.main }}
            >
              درخواست شما با موفقیت ارسال شد!
            </Typography>

            <Box
              sx={{
                mb: 4,
                p: 3,
                bgcolor: alpha(theme.palette.info.main, 0.1),
                borderRadius: 2,
              }}
            >
              <Typography variant="body1" paragraph>
                درخواست ثبت‌نام شما دریافت شد و در صف بررسی قرار گرفت.
              </Typography>
              <Typography variant="body1" paragraph>
                تیم ما طی <strong>۳ تا ۵ روز کاری</strong> مدارک و اطلاعات شما
                را بررسی خواهد کرد.
              </Typography>
              <Typography variant="body1">
                نتیجه بررسی از طریق <strong>پیامک</strong> و{" "}
                <strong>ایمیل</strong> به اطلاع شما خواهد رسید.
              </Typography>

              {trackingNumber ? (
                <Box
                  sx={{
                    mt: 2.5,
                    py: 1.5,
                    px: 2,
                    borderRadius: 1.5,
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.25)}`,
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    شماره پیگیری
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, mt: 0.5 }}>
                    {trackingNumber}
                  </Typography>
                </Box>
              ) : null}
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 4 }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  borderRadius: 1,
                }}
              >
                <SmsIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                <Typography variant="body2">اطلاع‌رسانی پیامکی</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  bgcolor: alpha(theme.palette.secondary.main, 0.1),
                  borderRadius: 1,
                }}
              >
                <EmailIcon
                  sx={{ mr: 1, color: theme.palette.secondary.main }}
                />
                <Typography variant="body2">اطلاع‌رسانی ایمیلی</Typography>
              </Box>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              در صورت داشتن سوال، می‌توانید با شماره 09135517831 تماس بگیرید.
            </Typography>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mb: 2 }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/")}
                sx={{ px: 4 }}
              >
                بازگشت به صفحه اصلی
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default RegistrationSuccessPage;
